const workercode = () => {
    let timeOutId;
    /* eslint-disable-next-line no-restricted-globals */
    self.onmessage = function (e) {
        /* eslint-disable-next-line no-restricted-globals */
        if (timeOutId) {
            clearTimeout(timeOutId);
        }
        if (e.data.action === "tryReconnect") {
            timeOutId = setTimeout(() => {
                const workerResult = "Received from main: " + e.data;
                /* eslint-disable-next-line no-restricted-globals */
                self.postMessage(workerResult); // eslint-disable-line no-restricted-globals
            }, 5000);
        }
    };
};

let code = workercode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);

export default worker_script;
